import { render, staticRenderFns } from "./purchasedetail.vue?vue&type=template&id=3f55b720"
import script from "./purchasedetail.vue?vue&type=script&lang=js"
export * from "./purchasedetail.vue?vue&type=script&lang=js"
import style0 from "./purchasedetail.vue?vue&type=style&index=0&id=3f55b720&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports